<template>
  <ul :class="$style.root">
    <slot />
  </ul>
</template>

<script>

export default {
  name: 'Registry',

  props: {
    value: String
  },

  model: {
    prop: 'value',
    event: 'change'
  },

  reactiveProvide: {
    name: 'Registry',
    include: [
      'value',
      'handleSelect'
    ]
  },

  methods: {
    handleSelect: function (value) {
      if (value !== this.value) {
        this.$emit('change', value);
      }
    }
  }
}

</script>

<style module>

.root {
  padding: 0;
  list-style-type: none;
}

</style>
